import { Type } from 'class-transformer';
import ConversationMessageMediaModel from './conversation-message-media.model';

export default class ConversationMessageMediaInfoModel {
  @Type(() => ConversationMessageMediaModel)
  media!: ConversationMessageMediaModel;

  downloadUrl!: string;
}
